<template>
    <div class="steps-bar d-flex align-items-center justify-content-center">
        <ul class="d-flex m-0">
            <li v-for="(step, index) in steps" :key = "step.name" class="d-flex align-items-center">
                <div 
                    class="step-number d-flex justify-content-center align-items-center"
                    :class="{
                        'completed': index <= activeIndex,
                        'not-completed': index > activeIndex,
                        }"
                >
                        <Icon icon="checkmark" v-if="index < activeIndex"/>
                        <span v-else>{{index + 1}}</span>
                </div>
                <p class="m-0">{{step.name}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
import Icon from '../../../components/Theme/Icon'
export default {
    name: 'StepsBar',
    components: {
        Icon
    },
    data(){
        return {
            steps: [
                {name: 'Add Shop Link'},
                {name: 'Create Shop Profile'},
                {name: 'CrossProm Mediums'},
                {name: 'Verify Shop'}
            ]
        }
    },
    props: {
        activeIndex: Number
    }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';
.steps-bar {
    height: 52px;
    margin-top: 0px;
    background: #fff;
    position: absolute;
    top: 60px;
    width: 100%;
    
    ul {
        padding: 0;
    }

    ul li {
        // width: 25vw;

        &:last-child {
            width: auto;
        }

        &:first-child .step-number{
            margin-left: 0;
        }

        p {
            flex-shrink: 0;
        }

        .step-number {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            padding-bottom: 0;
            flex-shrink: 0;
            color: #fff;
            margin: 0 15.5px;
            
            &.completed {
                background: $c1;
            }
            &.not-completed {
                background: #9BA6B4;
                
            }

            span {
                margin-bottom: 2px;
            }
            
        }
    }
    ul li:not(:last-child):after {
        display: block;
        width: 10vw;
        max-width: 300px;
        content: '';
        background: #E2E8F0;
        height: 1px;
        margin-left: 12px;

        @media screen and (max-width: 1100px) {
            width: 10px;
            // display: none;
        }
    }
}
</style>